import { Component, OnInit } from '@angular/core';
import { NavItem } from "../../../models/navItem";
import { Router, RouterLink } from "@angular/router";
import { NgClass } from "@angular/common";
import { SvgIconComponent } from "angular-svg-icon";
import { EstablishmentService } from "../../../services/establishment.service";
import { CandidatService } from "../../../services/candidat.service";
import { AuthService } from '../../../services/auth.service';
import { userType } from '../../../shared/utils/enums';

@Component({
  selector: 'app-agency-sidebar',
  templateUrl: './agency-sidebar.component.html',
  styleUrl: './agency-sidebar.component.scss',
  imports: [
    NgClass,
    SvgIconComponent,
    RouterLink
  ],
  standalone: true
})
export class AgencySidebarComponent implements OnInit {
  navList: NavItem[] = [
    {
      id: 1, label: 'Gestion des établissements', icon: 'company', route: '/agency/establishment',
      activatedOn: ['/agency/establishment', '/agency/details-establishment', '/agency/mission-by-establishment']
    },
    {
      id: 2,
      label: 'Gestion des professionnels de santé',
      icon: 'doctor',
      route: 'agency/candidates',
      activatedOn: ['/agency/candidates', '/details-candidate']
    },
    {
      id: 3,
      label: 'Gestion de vos agences',
      icon: 'agency',
      route: 'agency/agencies',
      activatedOn: ['/agency/agencies']
    },
    {
      id: 4,
      label: 'Gestions de vos accès',
      icon: 'padlock-tools',
      route: 'agency/users',
      activatedOn: ['/agency/users', '/agency/details-user']
    },
    // {
    //   id: 5,
    //   label: 'Gestion centralisée des missions en cours',
    //   icon: 'target',
    //   route: '/agency/missions',
    //   activatedOn: ['/agency/missions']
    // },
    // {
    //   id: 6,
    //   label: 'Rapports Hebdomadaires',
    //   icon: 'document',
    //   route: '/agency/weekly-reports',
    //   activatedOn: ['/agency/weekly-reports']
    // },
    {
      id: 7,
      label: 'Affectation directe',
      icon: 'target',
      route: '/agency/direct-assign',
      activatedOn: ['/agency/direct-assign']
    },
    {
      id: 8,
      label: "Relevés d'heures",
      icon: 'document',
      route: '/agency/weekly-hours',
      activatedOn: ['/agency/weekly-hours']
    },
    // {
    //   id: 9,
    //   label: 'Paie',
    //   icon: 'document',
    //   route: '/agency/payroll',
    //   activatedOn: ['/agency/payroll']
    // },
  ]
  navListUser: NavItem[] = [
    {
      id: 1, label: 'Gestion des établissements', icon: 'company', route: '/agency/establishment',
      activatedOn: ['/agency/establishment', '/agency/details-establishment', '/agency/mission-by-establishment']
    },
    {
      id: 2,
      label: 'Gestion des professionnels de santé',
      icon: 'doctor',
      route: 'agency/candidates',
      activatedOn: ['/agency/candidates', '/details-candidate']
    },
    {
      id: 7,
      label: 'Affectation directe',
      icon: 'target',
      route: '/agency/direct-assign',
      activatedOn: ['/agency/direct-assign']
    },
  ]
  previousUrl: string;

  routeSelected: number | undefined = 1;

  constructor(private router: Router,
    private auth: AuthService,
    private etbApi: EstablishmentService,
    private candidateApi: CandidatService) {
    this.auth.user?.kind == userType.agence ? this.navList = this.navList : this.navList = this.navListUser;
    const url = router.url;
    router.events.subscribe((val: any) => {
      if (val.url) {
        this.routeSelected = this.navList.find(a => {
          return a.activatedOn?.filter(p => val.url.includes(p))?.length!! > 0
        })?.id
      }
    });
  }

  ngOnInit(): void {
    // this.etbApi.getAgencyEstablishments().subscribe();
    // this.candidateApi.getAgencyCandidates().subscribe();
  }

  routeClick(item: NavItem) {
    this.router.navigate([item.route])
    this.routeSelected = item.id;
  }
}
